"use client";

import React from 'react';
import { useContactModal } from '@/hooks/useContactModal';
import ContactModal from './ContactModal';

interface ContactModalButtonProps {
  children: React.ReactNode;
  source?: string;
  className?: string;
}

export default function ContactModalButton({ 
  children, 
  source = 'unknown', 
  className = '' 
}: ContactModalButtonProps) {
  const { isContactModalOpen, openContactModal, closeContactModal } = useContactModal();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    openContactModal(source);
  };

  return (
    <>
      <button 
        onClick={handleClick}
        className={className}
        type="button"
      >      {children}
      </button>
      
      <ContactModal 
        isOpen={isContactModalOpen}
        onClose={closeContactModal}
        triggerSource={source}
      />
    </>
  );
}
